import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { postApi, getApi } from '../service/service';
import { API_URL } from '../config';
import CircularLoader from '../components/common/loader/loader';
import { toast } from '../utils/toast';
import { getToken, getUserLoginName, getUserRole, isAuthenticated } from '../utils/auth';

class Archive extends Component {
  state = {
    isLoading: true,
    archivedList: [],
  };

  componentDidMount() {
    // Check if user is authenticated
    if (!isAuthenticated() || !getToken()) {
      toast.error('You must be logged in to access the archive.');
      this.props.history.push('/login');
      return;
    }
    this.getArchivedList(`${API_URL}/satsang/archived`);
  }

  getArchivedList = (apiUrl) => {
    const token = getToken();
    if (!token) {
      toast.error('You must be logged in to access the archive.');
      this.props.history.push('/login');
      return;
    }

    let header = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    let body = {};
    postApi(apiUrl, header, body).then((data) => {
      this.setState({ isLoading: false });
      if (data.status && data.data) {
        // Backend already returns only archived items (isDeleted === true)
        this.setState({ archivedList: data.data });
      } else {
        this.setState({ archivedList: [] });
      }
    }).catch((error) => {
      this.setState({ isLoading: false, archivedList: [] });
      const errorMessage = error.message || error.msg || 'Failed to load archived posts. Please try again.';
      toast.error(errorMessage);
      
      // If unauthorized, redirect to login
      if (error.statusCode === 401 || error.statusCode === 403) {
        this.props.history.push('/login');
      }
    });
  };

  restoreSatsang = (id) => {
    // First get the satsang data to preserve all fields
    const token = getToken();
    const userloginname = getUserLoginName();
    let header = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    getApi(`${API_URL}/satsang/${id}`, header).then((response) => {
      // Backend returns { status: true, data: [...] }
      const data = response.data || response;
      if (data && Array.isArray(data) && data.length) {
        // Use update API to set isDeleted: false
        let updateHeader = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          updateBody = {
            id: id,
            name: data[0].name,
            description: data[0].description,
            user: userloginname,
            category: data[0].category,
            isDeleted: false,
          };
        postApi(`${API_URL}/satsang/addUpdate`, updateHeader, updateBody).then((result) => {
          if (result.status || result.success) {
            toast.success('Satsang restored successfully!');
            // Refresh the archived list
            this.getArchivedList(`${API_URL}/satsang/archived`);
          } else {
            // Backend uses 'msg' field for errors
            const errorMessage = result.msg || result.message || result.error || 'Failed to restore satsang. Please try again.';
            toast.error(errorMessage);
          }
        }).catch((error) => {
          const errorMessage = error.message || error.msg || 'An error occurred. Please try again.';
          toast.error(errorMessage);
          
          // If unauthorized, redirect to login
          if (error.statusCode === 401 || error.statusCode === 403) {
            window.location.href = '/login';
          }
        });
      } else {
        toast.error('Satsang not found or you do not have permission to view it.');
      }
    }).catch((error) => {
      const errorMessage = error.message || error.msg || 'Failed to fetch satsang data. Please try again.';
      toast.error(errorMessage);
      
      // If unauthorized, redirect to login
      if (error.statusCode === 401 || error.statusCode === 403) {
        window.location.href = '/login';
      }
    });
  };

  permanentDeleteSatsang = (id) => {
    if (window.confirm('Are you sure you want to permanently delete this item? This action cannot be undone.')) {
      // Use the same delete API as jivini.jsx
      const token = getToken();
      const userloginname = getUserLoginName();
      let header = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body = { 
          id: id,
          user: userloginname
        };
      postApi(`${API_URL}/satsang/delete`, header, body).then((data) => {
        if (data.status || data.success) {
          toast.success('Satsang permanently deleted successfully!');
          // Refresh the archived list
          this.getArchivedList(`${API_URL}/satsang/archived`);
        } else {
          // Backend uses 'msg' field for errors
          const errorMessage = data.msg || data.message || data.error || 'Failed to delete satsang. Please try again.';
          toast.error(errorMessage);
        }
      }).catch((error) => {
        const errorMessage = error.message || error.msg || 'An error occurred. Please try again.';
        toast.error(errorMessage);
        
        // If unauthorized, redirect to login
        if (error.statusCode === 401 || error.statusCode === 403) {
          window.location.href = '/login';
        }
      });
    }
  };

  render() {
    const { isLoading, archivedList } = this.state;
    const role = getUserRole();
    const isSuperAdmin = role === 'superadmin';

    return (
      <div style={{ minHeight: '700px' }}>
        <div className="jumbotron" style={{ marginBottom: '4%' }}></div>
        {isLoading ? (
          <div className="loader-container">
            <CircularLoader />
          </div>
        ) : (
          <div className="main-page-container" style={{ position: 'static', width: 'auto' }}>
            <h5>Archived Posts</h5>
            <div style={{ position: 'inherit', width: '90%', height: 'auto' }}>
              {archivedList.length === 0 ? (
                <p>No archived posts found.</p>
              ) : (
                <ul className="navbar-nav ml-auto">
                  {archivedList.map((row) => {
                    const categoryNames = {
                      1: 'स्वामी जी सत्संग',
                      2: 'बड़ेला-धाम सत्संग',
                      3: 'प्रचलित-प्रार्थनायें',
                      4: 'कहानियां',
                      5: 'जीवन-परिचय',
                      6: 'बड़ेला-धाम परिचय',
                      7: 'निज अंतर-अनुभव',
                      8: 'नवीन सुचनायें',
                      9: 'स्वामी जी फोटो गैलरी',
                      10: 'बड़ेला-धाम फोटो गैलरी',
                      11: 'world message',
                      12: 'आंतरिक प्रार्थना',
                      13: 'प्रमुख अन्तर्घट संदेश',
                      14: 'साधकों की कलम से',
                    };
                    const categoryName = categoryNames[row.category] || 'Unknown';

                    return (
                      <li key={row._id} style={{ marginBottom: '15px', padding: '10px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '1.2em', fontWeight: 'bold', color: '#1717e6', marginBottom: '5px' }}>
                              {row.name}
                            </div>
                            <div style={{ fontSize: '0.9em', color: '#666' }}>
                              Category: {categoryName}
                            </div>
                            {row.createdAt && (
                              <div style={{ fontSize: '0.8em', color: '#999' }}>
                                Created: {new Date(row.createdAt).toLocaleString()}
                              </div>
                            )}
                            {row.userEmail && (
                              <div style={{ fontSize: '0.8em', color: '#999', marginTop: '3px' }}>
                                Created by: {row.userEmail}
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '10px' }}>
                            <Button
                              variant="success"
                              size="sm"
                              onClick={() => this.restoreSatsang(row._id)}
                            >
                              Restore
                            </Button>
                            {isSuperAdmin && (
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => this.permanentDeleteSatsang(row._id)}
                              >
                                Permanent Delete
                              </Button>
                            )}
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Archive);




// WEBPACK FOOTER //
// ./src/pages/Archive.jsx